import React, {ReactNode} from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import 'leaflet/dist/leaflet.css';
import '../../src/assets/css/index.css';

import 'swiper/css/swiper.min.css';
import 'aos/dist/aos.css';

interface TopLayoutProps {
    children: ReactNode;
}

export default function TopLayout(props: TopLayoutProps) {
    return (
        <>
        <Helmet>
            <title>Czysta Energia dla każdego!</title>
            <meta charSet="utf-8"/>
            <meta
                name="viewport"
                content="minimum-scale=1, initial-scale=1, width=device-width"
            />
            <link rel="shortcut icon" href="./../../src/assets/favicon.svg/"/>
            <meta name="theme-color" content="#ffffff"/>
            <meta
                name="description"
                content="Czysta energia dla każdego. Zainwestuj w fotowoltaikę, pompę ciepła, rekuperację lub klimatyzację i oszczędzaj na rachunkach."
            />
            <meta
                name="robots"
                content="max-snippet:-1, max-image-preview:large, max-video-preview:-1"
            />
            <meta property="og:locale" content="pl_PL"/>
            <meta property="og:type" content="website"/>
            <meta
                property="og:image"
                content="./white.svg"
            />
            <meta
                property="og:title"
                content="Czysta Energia dla każdego!"
            />
            <meta
                property="og:description"
                content="Czysta energia dla każdego. Zainwestuj w fotowoltaikę, pompę ciepła, rekuperację lub klimatyzację i oszczędzaj na rachunkach."
            />
            <meta property="og:url" content="https://bntech.dev"/>
            <link
                href="https://fonts.googleapis.com/css?family=Inter:100,100i,300,300i,400,400i,700,700i,900,900i&display=swap"
                rel="stylesheet"
            />
            <link
                rel="stylesheet"
                href="./index.css"/>
        </Helmet>
    {
        props.children
    }
</>
)
    ;
}

TopLayout.propTypes = {
    children: PropTypes.node,
};
